import React, { useRef } from "react";
import { Tooltip as ReactTooltip } from "react-tooltip";
import Icon from "components/Icon";
import { DateTime as Luxon } from "luxon";
import PropTypes from "prop-types";

const BlackListAlert = ({ blacklisted, id }) => {
    if (!blacklisted?.length) {
        return null;
    }

    const iconRef = useRef(null);

    return (
        <>
            <div className="players-list__item-icons" ref={iconRef}>
                <span
                    className="icon-container icon-container_error"
                    data-tooltip-id={id + `black-list`}
                >
                    <Icon type="alert" inheritColor inheritSize />
                </span>
            </div>
            <div className="tooltip tooltip-invite-black-list">
                <ReactTooltip
                    id={id + `black-list`}
                    place={"bottom"}
                    closeOnScroll
                    className="tooltip-react-black-list"
                    render={() => (
                        <div className="tooltip-black-list-container">
                            <div>
                                Этот игрок находится в черном списке у
                                организаторов:
                            </div>
                            {blacklisted.map(
                                ({ creator, reason, created_at }, key) => (
                                    <div key={key} className="mt-10 ellipsis">
                                        {Luxon.fromSQL(created_at).toFormat(
                                            "dd.LL.yyyy"
                                        )}
                                        , {creator?.full_name}- {reason}
                                    </div>
                                )
                            )}
                        </div>
                    )}
                />
            </div>
        </>
    );
};

BlackListAlert.propTypes = {
    blacklisted: PropTypes.array,
    id: PropTypes.string || PropTypes.number,
};

export default BlackListAlert;
